import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-down",
  "use": "arrow-angle-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-down\"><path d=\"M4.207 6.208c-.536.536.138 1.086.138 1.086l3.654 3.654 3.657-3.658c0 .004.638-.578.134-1.082-.504-.504-1.08.138-1.08.132L8 9.052 5.293 6.346c0-.006-.55-.674-1.086-.138z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol